import { Component, EventEmitter, Input, Output } from '@angular/core';
import { baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-cancel-payments-info',
  templateUrl: './cancel-payments-info.component.html',
})
export class CancelPaymentsInfoComponent {
  @Input() public contentStyle: baseCssConfigStyle;
  @Input() public colorTextAlignStyle: baseCssConfigStyle;
  @Input() public renderedContent = '';
  @Input() public selectedTextStyleClass = '';

  @Output() actionClick = new EventEmitter<void>();

  public onActionClick(): void {
    this.actionClick.emit();
  }
}
